/**
 * Bold Soul Studio — Custom JS
 * Fabriq pro pack qty enforcement
 */

(function() {

  window.bssProPackQtys = window.bssProPackQtys || {};

  function getPackQty(variantId) {
    return window.bssProPackQtys[String(variantId)] || 0;
  }

  function enforceCartInput(input) {
    var variantId = input.getAttribute('data-quantity-variant-id');
    if (!variantId) return;
    var packQty = getPackQty(variantId);
    if (!packQty) return;
    input.setAttribute('step', packQty);
    input.setAttribute('min', packQty);
    input.step = packQty;
    input.min  = packQty;
    var val = parseInt(input.value) || packQty;
    if (val < packQty) input.value = packQty;
  }

  function enforceAllCartInputs() {
    document.querySelectorAll('[data-quantity-variant-id]').forEach(enforceCartInput);
  }

  // Run after every cart update
  document.addEventListener('cartUpdated', function() {
    setTimeout(enforceAllCartInputs, 200);
    setTimeout(enforceAllCartInputs, 500);
  });

  // Watch cart-drawer custom element (active class toggled on THIS element, not .cart-drawer div)
  var cartDrawerEl = document.querySelector('cart-drawer');
  if (cartDrawerEl) {
    var wasActive = false;
    new MutationObserver(function() {
      var isActive = cartDrawerEl.classList.contains('active');
      if (isActive && !wasActive) {
        // Cart opened — enforce qty inputs
        setTimeout(enforceAllCartInputs, 100);
        setTimeout(enforceAllCartInputs, 300);
      }
      if (!isActive && wasActive) {
        // Cart closed — fire event so PDP can reapply pack rule
        setTimeout(function() {
          document.dispatchEvent(new CustomEvent('bss:cartClosed'));
        }, 100);
      }
      wasActive = isActive;
    }).observe(cartDrawerEl, { attributes: true, attributeFilter: ['class'] });
  }

  // Collection page quick add
  document.addEventListener('submit', function(e) {
    var form = e.target;
    if (!form || form.tagName !== 'FORM') return;
    var idInput = form.querySelector('[name="id"]');
    if (!idInput) return;
    var packQty = getPackQty(idInput.value);
    if (!packQty) return;
    var qtyInput = form.querySelector('[name="quantity"], .quantity__input');
    if (qtyInput) {
      var qty = parseInt(qtyInput.value) || 1;
      if (qty < packQty) qtyInput.value = packQty;
    } else {
      var hiddenQty = form.querySelector('input[name="quantity"][type="hidden"]');
      if (!hiddenQty) {
        hiddenQty = document.createElement('input');
        hiddenQty.type = 'hidden';
        hiddenQty.name = 'quantity';
        form.appendChild(hiddenQty);
      }
      hiddenQty.value = packQty;
    }
  }, true);

  // Init
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      enforceAllCartInputs();
    });
  } else {
    enforceAllCartInputs();
  }

})();

// ── Cross-domain cart persistence ─────────────────────────────────────────
// When switching between consumer and pro domains, restore cart via token in URL

(function() {
  var params = new URLSearchParams(window.location.search);
  var cartToken = params.get('cart_token');

  if (cartToken) {
    // Associate this cart token with the current session
    fetch('/cart/restore/' + cartToken, {
      method: 'GET',
      credentials: 'include'
    }).then(function() {
      // Remove cart_token from URL without reloading
      params.delete('cart_token');
      var newUrl = window.location.pathname + (params.toString() ? '?' + params.toString() : '');
      window.history.replaceState({}, '', newUrl);
    }).catch(function(err) {
      console.log('Cart restore failed:', err);
    });
  }
})();